export default __webpack_public_path__ + "static/Avenir-Book-be9ab5334998e415ea05d6acf062bfe7.otf";